export const ENDPOINTS = {
    AUTH_LOGIN: "/login",
    AUTH_REGISTER: "/register",
    AUTH_LOGOUT: "/logout",
    COURSES: {
        LIST: "/courses",
        SHOW: (id: number | string) => `/courses/${id}`,
        CREATE: "/courses",
        UPDATE: (id: number | string) => `/courses/${id}`,
        DELETE: (id: number | string) => `/courses/${id}`,
        PUBLISH: (id: number | string) => `/courses/${id}/publish`,
        ENROLL: (id: number | string) => `/courses/${id}/enroll`,
        MY_COURSES: "/courses/my",
    },
    CATEGORIES: {
        LIST: "/categories",
        SHOW: (id: number | string) => `/categories/${id}`,
        CREATE: "/categories",
        UPDATE: (id: number | string) => `/categories/${id}`,
        DELETE: (id: number | string) => `/categories/${id}`,
    },
    STUDENT: {
        DASHBOARD: "/student/dashboard",
        ENROLLMENTS: "/student/dashboard/enrollments",
        OVERVIEW: "/student/dashboard/overview",
        CERTIFICATES: "/student/dashboard/certificates",
        ENROLLMENT_DETAIL: (id: number | string) => `/student/dashboard/enrollments/${id}`,
        CERTIFICATE_DOWNLOAD: (id: number | string) => `/student/dashboard/certificates/${id}/download`,
    },
    INSTRUCTOR: {
        DASHBOARD: "/instructor/dashboard",
        OVERVIEW: "/instructor/dashboard/overview",
        REVENUE: "/instructor/dashboard/revenue",
        MY_COURSES: "/instructor/dashboard/courses",
        EARNINGS: '/instructor/earnings',
        PAYOUT_SETTINGS: '/instructor/payout-settings',
        REQUEST_PAYOUT: '/instructor/request-payout',
    },
    CHAPTERS: {
        BY_COURSE: (courseId: number | string) => `/courses/${courseId}/chapters`,
        SHOW: (courseId: number | string, chapterId: number | string) => `/courses/${courseId}/chapters/${chapterId}`,
        CREATE: (courseId: number | string) => `/courses/${courseId}/chapters`,
        UPDATE: (courseId: number | string, chapterId: number | string) => `/courses/${courseId}/chapters/${chapterId}`,
        DELETE: (courseId: number | string, chapterId: number | string) => `/courses/${courseId}/chapters/${chapterId}`,
        REORDER: (courseId: number | string) => `/courses/${courseId}/chapters/reorder`,
    },
    LESSONS: {
        BY_CHAPTER: (chapterId: number | string) => `/chapters/${chapterId}/lessons`,
        SHOW: (chapterId: number | string, lessonId: number | string) => `/chapters/${chapterId}/lessons/${lessonId}`,
        CREATE: (chapterId: number | string) => `/chapters/${chapterId}/lessons`,
        UPDATE: (chapterId: number | string, lessonId: number | string) => `/chapters/${chapterId}/lessons/${lessonId}`,
        DELETE: (chapterId: number | string, lessonId: number | string) => `/chapters/${chapterId}/lessons/${lessonId}`,
        REORDER: (chapterId: number | string) => `/chapters/${chapterId}/lessons/reorder`,
        COMPLETE: (chapterId: number | string, lessonId: number | string) => `/chapters/${chapterId}/lessons/${lessonId}/complete`,
        PROGRESS: (chapterId: number | string, lessonId: number | string) => `/chapters/${chapterId}/lessons/${lessonId}/progress`,
    },
    QUESTIONS: {
        CREATE: (testId: number | string) => `/tests/${testId}/questions`,
        UPDATE: (testId: number | string, questionId: number | string) => `/tests/${testId}/questions/${questionId}`,
        DELETE: (testId: number | string, questionId: number | string) => `/tests/${testId}/questions/${questionId}`,
    },
    SUBMISSIONS: {
        DRAFT: (testId: number | string) => `/tests/${testId}/submissions/draft`,
        SUBMIT: (testId: number | string) => `/tests/${testId}/submissions/submit`,
        GRADE: (submissionId: number | string) => `/submissions/${submissionId}/grade`,
    },
    TESTS: {
        CREATE: "/tests",
        SHOW: (id: number | string) => `/tests/${id}`,
        START: (testId: number | string) => `/tests/${testId}/start`,
        UPDATE: (id: number | string) => `/tests/${id}`,
        DELETE: (id: number | string) => `/tests/${id}`,
        MY_SUBMISSIONS: (testId: number | string) => `/tests/${testId}/my-submissions`,
        PENDING_GRADINGS: "/tests/pending-gradings",
        BY_COURSE: (courseId: number | string) => `/courses/${courseId}/tests`,
        BY_CHAPTER: (chapterId: number | string) => `/chapters/${chapterId}/tests`,
        BY_LESSON: (lessonId: number | string) => `/lessons/${lessonId}/tests`,
    },
    CURRENCY: {
        RATES: (base: string) => `/currency/rates/${base}`,
        CONVERT: '/currency/convert',
        UPDATE_PREFERENCE: '/user/settings/currency',
    },
    PAYMENT_METHODS: {
        LIST: '/payment-methods',
        CREATE: '/payment-methods',
        DELETE: (id: number) => `/payment-methods/${id}`,
        SET_DEFAULT: (id: number) => `/payment-methods/${id}/default`,
    },
    USER_SETTINGS: {
        UPDATE_PROFILE: '/user/profile',
        UPDATE_PASSWORD: '/user/password',
    },
    LEGAL: {
        GET_BY_SLUG: (slug: string) => `/legal/${slug}`,
        ADMIN_LIST: '/admin/legal',
        ADMIN_UPSERT: (slug: string) => `/admin/legal/${slug}`,
    },
    SUBSCRIPTION: {
        CURRENT: '/subscription/current',
        PLANS: '/subscription/plans',
        USAGE: '/subscription/usage',
        HISTORY: '/subscription/history',
        UPGRADE_PREVIEW: (planId: number) => `/subscription/upgrade/preview/${planId}`,
        UPGRADE: '/subscription/upgrade',
        DOWNGRADE: '/subscription/downgrade',
        CANCEL: '/subscription/cancel',
    },
    ADMIN_SUBSCRIPTION: {
        PLANS: '/admin/subscription-plans',
        CREATE_PLAN: '/admin/subscription-plans',
        SHOW_PLAN: (id: number) => `/admin/subscription-plans/${id}`,
        UPDATE_PLAN: (id: number) => `/admin/subscription-plans/${id}`,
        DELETE_PLAN: (id: number) => `/admin/subscription-plans/${id}`,
        SET_LIMITS: (id: number) => `/admin/subscription-plans/${id}/limits`,
        SET_FEATURES: (id: number) => `/admin/subscription-plans/${id}/features`,
    },
    PAYMENTS: {
        CALCULATE: (courseId: number | string) => `/payments/calculate/${courseId}`,
        CREATE: '/payments/create',
        COMPLETE_TRANSACTION: '/payments/complete-transaction',
        COMPLETE: (paymentId: number | string) => `/payments/${paymentId}/complete`,
        MY_PAYMENTS: '/payments/my-payments',
        REFUND: (paymentId: number | string) => `/payments/${paymentId}/refund`,
    },
    PUBLIC_PLANS: "/plans",
};

export default ENDPOINTS;
